export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_RECEIVE_BASE = 'SHOW_RECEIVE_BASE';
export const SHOW_RECEIVE_CUSTOMIZE_FIELD = 'SHOW_RECEIVE_CUSTOMIZE_FIELD';
export const SHOW_RECEIVE_BUSINESS = 'SHOW_RECEIVE_BUSINESS';
export const SHOW_RECEIVE_WORKER = 'SHOW_RECEIVE_WORKER';
export const SHOW_RECEIVE_WORKFLOW = 'SHOW_RECEIVE_WORKFLOW';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const COUNT_START = 'COUNT_START';
export const COUNT_SUCCESS = 'COUNT_SUCCESS';
export const COUNT_FAILURE = 'COUNT_FAILURE';

export const CLEAR_ON_ROUTE = 'CLEAR_ON_ROUTE';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
